const DISPLAY = Object.freeze({
  ERROR: Symbol('error'),
  WAITING: Symbol('waiting'),
  REPORT: Symbol('report'),
});

export default DISPLAY;
